<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <striketrough><span class="font-weight-bold h5">Settings</span></striketrough>
                <personal-details />
                <account-details />
                <contact-address />
                <div class="card shadow-sm mb-4">
                    <div class="card-body px-3 pt-lg-5 px-3 px-lg-4">
                        <div class="d-flex flex-row align-items-start ">
                            <img src="../../assets/images/setup/creditcard.svg" alt="" class="mr-3" style="width: 29px">
                            <h3>Direct Debit Details</h3>
                        </div>
                        <div class="row">
                            <div class="col-12 col-lg-3">
                                <a href="#" class="mt-4 float-right btn btn-success btn-success-gradient btn-block"
                                   @click.prevent="$refs.directDebitFormModal.show()">Update Direct Debit details</a>
                            </div>
                        </div>
                    </div>
                </div>
                <property-details />
            </div>
        </div>
        <modal ref="directDebitFormModal" dialog-class="modal-lg direct-debit-modal" body-class="px-2 px-lg-5 pb-5">
            <h5 class="text-center mb-2 mb-lg-5">As part of the switching process we'll pass your details to your new energy
                supplier,
                <br/> so they can bill you when the switch has been completed.</h5>
            <direct-debit-form update ref="directDebitForm"/>
            <div class="form-row mb-4">
                <div class="col-12 col-sm-4 offset-sm-4 col-md-3 offset-md-6 mt-3">
                    <button class="btn btn-lg btn-outline-info btn-block px-5" @click="$refs.directDebitFormModal.hide()">
                        Cancel
                    </button>
                </div>
                <div class="col-12 col-sm-4 col-md-3 mt-3">
                    <button class="btn btn-lg btn-success btn-success-gradient btn-block px-5 " @click="update">Update</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import Striketrough from "@/components/support/Striketrough";
import Modal from "@/components/Modal";
import DirectDebitForm from "@/components/setup/DirectDebitForm";
import api from "@/utils/api"
import PersonalDetails from "@/components/profile/PersonalDetails";
import AccountDetails from "@/components/profile/AccountDetails";
import PropertyDetails from "@/components/profile/PropertyDetails";
import ContactAddress from "@/components/profile/ContactAddress";

export default {
    name: "Settings",
    components: {
        ContactAddress,
        PropertyDetails,
        AccountDetails,
        PersonalDetails, DirectDebitForm, Modal, Striketrough
    },
    methods: {
         update() {
             let that = this;
            this.$refs.directDebitForm.$v.$touch()
            if (this.$refs.directDebitForm.$v.$invalid) {
                return
            }
            this.$refs.directDebitForm.clearErrors();
            let data =  this.$refs.directDebitForm.getFormData();
            api.savePaymentDetails({
                accountName: data.accountName,
                accountNumber: data.accountNumber,
                bankSortCode: data.bankSortCode,
                update: true
            }).then(() => {
                that.$refs.directDebitFormModal.hide()
                that.$toast.success("Direct Debit Data updated successfully!");
            }).catch(e => {
                if(e.response.status === 400 && e.response.data.error.code === 11111){
                    that.$refs.directDebitForm.setErrors(e.response.data.meta);
                }
                that.$toast.error("Problem with updating Direct Debit Data!");
            })
        }
    },
    mounted() {
        let that = this;
        if (this.$store.getters['setup/isDataEmpty']) {
            api.survey().then(response => {
                that.$store.commit('setup/setData', response.data.data)
            })
        }
    }
}
</script>


<style scoped lang="scss">
@import "../../sass/base";

::v-deep .direct-debit-modal {
    max-width: 1140px;
    .modal-body {
        @include media-breakpoint-down(lg) {
            height: 90vh;
        }
        overflow-y: auto;
    }
}
</style>
